/** @format */

// Action types
export const SET_SKILL_TREE_CACHE = "SET_SKILL_TREE_CACHE";
export const GET_SKILL_TREE_CACHE = "GET_SKILL_TREE_CACHE";
export const CLEAR_SKILL_TREE_CACHE = "CLEAR_SKILL_TREE_CACHE";
export const SET_AI_CONFIGURATION = "SET_AI_CONFIGURATION";

// Action creators
export const setSkillTreeCache = (cacheKey, data) => ({
  type: SET_SKILL_TREE_CACHE,
  payload: { cacheKey, data },
});

export const getSkillTreeCache = (cacheKey) => ({
  type: GET_SKILL_TREE_CACHE,
  payload: { cacheKey },
});

export const clearSkillTreeCache = (cacheKey) => ({
  type: CLEAR_SKILL_TREE_CACHE,
  payload: { cacheKey },
});

export const setAIConfiguration = (data) => ({
  type: SET_AI_CONFIGURATION,
  payload: data,
});

// Helper function to generate cache key
export const generateCacheKey = (skillName, resultId, model) => {
  return `${skillName}_${resultId}_${model}`;
};

